module.exports = __webpack_public_path__ + "img/product_12.3e69baa.webp";